module.exports = __webpack_public_path__ + "img/excel.ddf2d916.png";